import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/common.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import rate from 'vue-rate';
import './assets/css/global.css'
import '../static/iconfont/iconfont.css'
import './assets/css/order.css'
import VideoPlayer from 'vue-video-player'
import http from './utils/http'
import store from './store/index'
// import vshare from 'vshare'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


Vue.config.productionTip = false
Vue.prototype.$axios = http; //接口管理
Vue.use(VideoPlayer)
Vue.use(rate)
// Vue.use(vshare)
/* eslint-disable no-new */
Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js